import React from 'react';

import PropTypes from 'prop-types';

import { AvatarContainer, AvatarImage, AvatarInitials } from './Avatar.styles';

const Avatar = ({ name = '', src = null, platform = 'facebook', size = 36 }) => {
  const [imageError, setImageError] = React.useState(false);
  const [imageLoaded, setImageLoaded] = React.useState(false);

  const getInitials = (fullName, platformType) => {
    if (!fullName || typeof fullName !== 'string') return '?';

    const trimmedName = fullName.trim();
    if (trimmedName.length === 0) return '?';

    if (platformType === 'instagram') {
      const letters = trimmedName
        .split('')
        .filter((char) => /[a-zA-Z]/.test(char))
        .slice(0, 2);

      if (letters.length === 0) return '?';
      if (letters.length === 1) return letters[0].toUpperCase();
      return letters.map((l) => l.toUpperCase()).join('');
    }

    const nameParts = trimmedName.split(/\s+/);

    if (nameParts.length === 0) return '?';
    if (nameParts.length === 1) {
      return nameParts[0][0].toUpperCase();
    }

    const firstInitial = nameParts[0][0].toUpperCase();
    const lastInitial = nameParts[nameParts.length - 1][0].toUpperCase();
    return `${firstInitial}${lastInitial}`;
  };

  const initials = getInitials(name, platform);
  const shouldShowInitials = !src || imageError || !imageLoaded;

  const handleImageError = () => {
    setImageError(true);
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  React.useEffect(() => {
    setImageError(false);
    setImageLoaded(false);
  }, [src]);

  return (
    <AvatarContainer size={size}>
      {src && !imageError && (
        <AvatarImage
          src={src}
          alt={name}
          onError={handleImageError}
          onLoad={handleImageLoad}
          $visible={imageLoaded}
          size={size}
        />
      )}
      {shouldShowInitials && (
        <AvatarInitials platform={platform} size={size}>
          {initials}
        </AvatarInitials>
      )}
    </AvatarContainer>
  );
};

Avatar.propTypes = {
  name: PropTypes.string,
  src: PropTypes.string,
  platform: PropTypes.oneOf(['facebook', 'instagram', 'whatsapp', 'imap']),
  size: PropTypes.number,
};

export default Avatar;
